// src/features/promoteur/ChargilyPaymentPage.jsx
import { useAuth } from "../../context/AuthContext";
import BoutonChargily from "./BoutonChargily";

const PLAN = {
  id: "monthly",
  label: "Pack Promoteur — Mensuel",
  description: "Publiez vos annonces immobilières sans limite pendant 30 jours.",
  amount: 299,
};

export default function ChargilyPaymentPage() {
  // AuthContext expose : user, role, isLoading
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f8fa" }}>
        <p style={{ color: "#6b7280", fontSize: "15px" }}>Chargement...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f8fa" }}>
        <div style={{ textAlign: "center", padding: "40px" }}>
          <p style={{ color: "#dc2626", fontSize: "15px", marginBottom: "16px" }}>
            Vous devez être connecté pour accéder à cette page.
          </p>
          <a href="/login" style={{ background: "#078D3F", color: "#fff", padding: "10px 22px", borderRadius: "10px", textDecoration: "none", fontWeight: "600" }}>
            Se connecter
          </a>
        </div>
      </div>
    );
  }

  // user.uid garanti ici — isLoading false + user non-null
  return (
    <div style={{ minHeight: "100vh", background: "#f7f8fa", padding: "40px 20px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: "650px", background: "#ffffff", borderRadius: "20px", padding: "35px 30px", boxShadow: "0 10px 30px rgba(0,0,0,0.08)" }}>

        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <h1 style={{ margin: "0 0 10px", fontSize: "28px", fontWeight: "700", color: "#111827" }}>
            Abonnement Promoteur
          </h1>
          <p style={{ margin: 0, fontSize: "15px", color: "#6b7280", lineHeight: "1.6" }}>
            Activez votre abonnement pour publier vos annonces.
          </p>
        </div>

        <div style={{ border: "1px solid #e5e7eb", borderRadius: "16px", padding: "24px", background: "#fafafa" }}>
          <h2 style={{ margin: "0 0 8px", fontSize: "20px", fontWeight: "700", color: "#111827" }}>
            {PLAN.label}
          </h2>
          <p style={{ margin: "0 0 18px", color: "#6b7280", fontSize: "14px", lineHeight: "1.6" }}>
            {PLAN.description}
          </p>

          <div style={{ marginBottom: "18px", padding: "10px 14px", background: "#f0faf6", borderRadius: "10px", border: "1px solid #a3d9c0", fontSize: "13px", color: "#0f6e56" }}>
            Connecté en tant que : <strong>{user.email}</strong>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "22px", padding: "14px 16px", background: "#fff", borderRadius: "12px", border: "1px solid #e5e7eb" }}>
            <span style={{ fontSize: "15px", fontWeight: "600", color: "#111827" }}>Montant</span>
            <span style={{ fontSize: "22px", fontWeight: "700", color: "#078D3F" }}>
              {PLAN.amount} DZD
              <span style={{ fontSize: "13px", fontWeight: "400", color: "#6b7280" }}> / mois</span>
            </span>
          </div>

       <BoutonChargily
  serviceName={PLAN.label}
  planId={PLAN.id}
  paymentMethod=""
  customerName={user.displayName || ""}
  customerEmail={user.email || ""}
  customerPhone={user.phoneNumber || ""}
  // ✅ Plus de amount ni userId
/>
        </div>
      </div>
    </div>
  );
}